import React from "react";
import styles from "./ui-element.module.scss";

export const Title = ({ title, subtitle }) => {
  return (
    <div className={styles.heading}>
      {title && <h3>{title}</h3>}
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
};

export default Title;
